export const formatDateWithSuffix = (dateString) => {
  const date = new Date(dateString)

  const day = date.getDate()
  const year = date.getFullYear()
  const month = date.toLocaleString('en-US', { month: 'long' }).toUpperCase() // "MAY"

  // Ordinal suffix logic
  const getOrdinal = (n) => {
    if (n >= 11 && n <= 13) return 'TH'
    switch (n % 10) {
      case 1:
        return 'ST'
      case 2:
        return 'ND'
      case 3:
        return 'RD'
      default:
        return 'TH'
    }
  }

  return `${day}${getOrdinal(day)} ${month}, ${year}`
}
